/**
 * FAQ — progressive enhancement.
 *
 * Markup to <details>/<summary>, który działa bez JS (natywne rozwijanie,
 * klawiatura, czytniki ekranu). Ten skrypt dodaje:
 *  - płynną animację rozwijania (grid-template-rows),
 *  - zachowanie akordeonu (otwarcie itemu zwija pozostałe).
 */
(function () {
    var SEL_BLOCK = '.wp-block-avangardo-faq';
    var SEL_ITEM = '.wp-block-avangardo-faq__item';
    var SEL_HEADER = '.wp-block-avangardo-faq__item-header';
    var SEL_ANSWER = '.wp-block-avangardo-faq__answer';

    function open(item) {
        item.open = true;
        // klasa dopiero w kolejnej klatce, żeby przejście 0fr -> 1fr
        // ruszyło z wyrenderowanego stanu zwiniętego
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                item.classList.add('is-open');
            });
        });
    }

    function close(item) {
        item.classList.remove('is-open');
        // atrybut open zdejmuje handler transitionend, żeby zawartość
        // nie znikała przed końcem animacji
    }

    function toggle(block, item) {
        var wasOpen = item.classList.contains('is-open');

        block.querySelectorAll(SEL_ITEM + '.is-open').forEach(function (el) {
            if (el !== item) close(el);
        });

        if (wasOpen) {
            close(item);
        } else {
            open(item);
        }
    }

    function handleClick(e) {
        var header = e.target.closest(SEL_HEADER);
        if (!header) return;
        var item = header.closest(SEL_ITEM);
        var block = header.closest(SEL_BLOCK);
        if (!item || !block) return;

        // przejmujemy natywne przełączanie <details>, żeby dograć animację;
        // klawiaturę załatwia <summary> — Enter/spacja emitują click
        e.preventDefault();
        toggle(block, item);
    }

    function init() {
        document.querySelectorAll(SEL_BLOCK).forEach(function (block) {
            // włącza CSS-owe zwijanie; bez JS <details> działa natywnie
            block.classList.add('is-enhanced');

            var opened = false;

            block.querySelectorAll(SEL_ITEM).forEach(function (item) {
                var answer = item.querySelector(SEL_ANSWER);
                if (!answer) return;

                answer.addEventListener('transitionend', function (e) {
                    if (e.propertyName === 'grid-template-rows' && !item.classList.contains('is-open')) {
                        item.open = false;
                    }
                });

                // akordeon: otwarty może być tylko pierwszy item z atrybutem
                // open; klasę is-open synchronizujemy z atrybutem, bo w markupie
                // może siedzieć stara klasa (np. zachowana w className bloku)
                var shouldOpen = item.open && !opened;
                if (shouldOpen) opened = true;
                item.open = shouldOpen;
                item.classList.toggle('is-open', shouldOpen);
            });
        });

        document.addEventListener('click', handleClick);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
